import React from "react";

import JobPage from "./JobPage";

const OpsManager = () => (
    <JobPage
        title="Operations & Finance Manager"
        location="Malta"
        summary={[
            "Undertake key administrative tasks with respect to corporate operations, legal, and compliance.",
            "Establish policies and procedures that promote company operations, culture, and vision.",
            "Monitor key invoices, accounting, audit, and bank processes.",
            "Manage compliance issues and coordinate with regulators.",
            "Assist in the development and deployment of key HR activities.",
            "Manage budgets (including at the project level) and develop accounting records and financial statements for the organization.",
            "Review financial statements and reports to ensure accuracy of data and adherence to accounting standards.",
            "Negotiate contracts with suppliers, vendors, and clients to secure new business opportunities or terminate existing relationships.",
            "Evaluate the effectiveness of company policies to ensure compliance with local, state, and national laws.",
            "Maximize efficiency and minimize costs by managing employee performance, conducting audits, and developing new strategies.",
            "Coordinate staff activities such as hiring, expense approvals, and budget monitoring.",
        ]}
        requirements={[
            "5+ years' experience in accounting, auditing, finance, managing regulators, operations, human resources, and legal.",
            "BS or higher.",
            "Experience in banking, payment processing, forex, brokerage services, and/or crypto.",
            "Familiarity within the startup or technology sector a plus.",
            "Proven track record of delivering on time, to specification.",
            "Experience with project management software for multi-disciplinary teams.",
            "Self-starter with a can-do attitude.",
        ]}
    />
);

export default OpsManager;
